import React from 'react';
import { saveAs } from 'file-saver';
import encoding from 'encoding-japanese';

import {Card, CardActions, CardHeader, CardText} from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import ContentRemove from 'material-ui/svg-icons/content/remove'
import FloatingActionButton from "material-ui/FloatingActionButton";
import * as colors from 'material-ui/styles/colors';
import $ from "jquery";
import _ from "lodash";
import Loading from './Loading';
import FormText from "./FormText";
import * as commons from "../commons";
import {Field, change, FieldArray, stopSubmit, startAsyncValidation, stopAsyncValidation} from "redux-form";
import FormSelect from "./FormSelect";
import MenuItem from "material-ui/MenuItem";
import FormAutoComplete2 from "./FormAutoComplete2";
import CostMonthCardContents from "./CostMonthCardContents";
import Dialog from 'material-ui/Dialog'
import YosanLeaner2 from './YosanLeaner2'
import Paper from "material-ui/Paper";
import styles from "../styles";
import FormCostContents from "./FormCostContents";
import moment from 'moment'


const validateCosts = (costs) => {

    if (!costs || !costs.length) {
        return []
    }

    const costsErrros = []
    costs.forEach((cost, index) => {
        const error = {}
        if (cost.budget && !commons.validateNumber(cost.budget)) {
            error.budget = '数値入力を入力して下さい。'
        }
        if (cost.result && !commons.validateNumber(cost.result)) {
            error.result = '数値入力を入力して下さい。'
        }
        // if (!cost.budget && cost.result) {
        //   error.result = '予算が未入力です。'
        // }
        if (!cost.costId && !cost.costName) {
            error.costItem = '必須入力'
        }
        costsErrros[index] = error
    })

    return costsErrros
}

class CostMonthCard extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            dialog: false,
            errors: []
        }
    }

    handleDownloadEnd() {
        this.setState(Object.assign(this.state, { loading: false }));
    }

    handleDownloadStart() {
        this.setState(Object.assign(this.state, { loading: true }));
    }

    loadingStop() {
        this.setState(Object.assign(this.state, { loading: false }));
    }

    dialogOpen() {
        this.setState(Object.assign(this.state, { dialog: true, loading: true }));
    }

    dialogClose() {

        const errors = validateCosts(this.props.costs);

        const errorsLength = errors.filter(x => !_.isEmpty(x)).length

        if (errorsLength != 0) {
            this.setState(Object.assign(this.state, { errors: errors }));
        } else {
            this.setState(Object.assign(this.state, { dialog: false, errors: [] }));
        }
    }

    handleCsvDownload(kind, month, costs, dataSource, start, end) {

        return function () {

            const download = (name, data) => {

                const unicodeList = [];
                for (let i = 0; i < data.length; i += 1) {
                    unicodeList.push(data.charCodeAt(i));
                }

                // 変換処理の実施
                const shiftJisCodeList = encoding.convert(unicodeList, 'sjis', 'unicode');
                const uInt8List = new Uint8Array(shiftJisCodeList);

                // csv書き込みの実装
                const writeData = new Blob([uInt8List], { type: 'text/csv' });

                saveAs(writeData, name);

                return;
                //
                // const mimeType = 'text/csv; charset=SHIFT-JIS'
                //
                // let blob = new Blob([data], {type: mimeType})
                // let downloadUrl = URL.createObjectURL(blob);
                //
                // let a = document.createElement("a");
                // a.href = downloadUrl
                // a.download = name
                // // a.target = '_blank'
                //
                // if (window.navigator.msSaveBlob) {
                //     // for IE
                //     window.navigator.msSaveBlob(blob, name)
                // } else if (window.URL && window.URL.createObjectURL) {
                //     // for Firefox
                //     a.href = window.URL.createObjectURL(blob);
                //     document.body.appendChild(a);
                //     a.click();
                //     document.body.removeChild(a);
                // } else if (window.webkitURL && window.webkitURL.createObject) {
                //     // for Chrome
                //     a.href = window.webkitURL.createObjectURL(blob);
                //     a.click();
                // } else {
                //     // for Safari
                //     window.open('data:' + mimeType + ';base64,' + window.Base64.encode(data), '_blank');
                // }

            }

            const name = kind + '_' + month.replace('/', '') + '.csv'

            if (kind == "労務費") {

                if (_.isEmpty(costs)) {
                    download(name, "no data")
                    return
                }

                start()

                const historyYearMonth = moment().format('YYYY/MM')
                const yosanId = costs[0].yosanId

                $.ajax({
                    url: `/bg/yosan/roumuCsv?id=${yosanId}&historyMonth=${historyYearMonth}&filterMonth=${month}`,
                    contentType: 'application/json',
                    timeout: 1000 * 100,
                    error: function () {
                    },
                    success: function (data) {

                        end()

                        download(name, data.result);

                    },
                    type: 'GET'
                });

            
            } else if (kind == "労務費（外部サイト連携）") {

                if (_.isEmpty(costs)) {
                    download(name, "no data")
                    return
                }

                start()

                const historyYearMonth = moment().format('YYYY/MM')
                const yosanId = costs[0].yosanId

                $.ajax({
                    url: `/bg/yosan/xronosRoumuCsv?id=${yosanId}&historyMonth=${historyYearMonth}&filterMonth=${month}`,
                    contentType: 'application/json',
                    timeout: 1000 * 100,
                    error: function () {
                    },
                    success: function (data) {

                        end()

                        download(name, data.result);

                    },
                    type: 'GET'
                });
    
            } else {

                const header = '項目,実績,予算,備考'
                const dataArray = costs.map(x => {
                    return this.getCostName(x.costId, x.costName, dataSource)
                        + ',' + (x.result ? x.result : 0)
                        + ',' + (x.budget ? x.budget : 0)
                        + ',' + x.comment
                })
                const data = dataArray.join("\n")

                download(name, header + "\n" + data)

            }

        }

    }

    getCostName(costId, costName, dataSource) {

        if (costName) {
            return costName
        }

        for (let i = 0; i < dataSource.length; i++) {
            const element = dataSource[i]
            if (element.id == costId) {
                return element.name
            }
        }

        return ""

    }

    render() {

        const {
            kind,
            name,
            month,
            costs,
            dataSourceConfig,
            dataSourceType,
            dataSource,
            resultDisable,
            status,
            parentIndex,
            dispatch,
            result,
            budget
        } = this.props


        const actions = [
            <FlatButton label="閉じる" primary={true} onClick={this.dialogClose.bind(this)}/>
        ]
        
        return (
            <div>
                <Card>
                    <CardHeader
                        title={month}
                        subtitle={(
                            <div>
                                <span style={{color: colors.grey600, fontSize: 11}}>
                                    合計 (実)
                                    <span style={{marginLeft: 10, fontSize: 23}}>
                                    {commons.dispMoney(result)}
                                    </span>
                                </span>
                                {
                                    !kind.startsWith("労務費") &&
                                    (
                                        <span style={{marginLeft: 20, color: colors.grey600, fontSize: 11}}>
                                            合計 (予)
                                            <span style={{marginLeft: 10, fontSize: 23}}>
                                            {commons.dispMoney(budget)}
                                            </span>
                                        </span>
                                    )
                                }
                            </div>
                        )}
                        subtitleStyle={{marginTop: 10}}
                        // actAsExpander={true}
                        // showExpandableButton={true}
                    >
                    </CardHeader>
                    <CardActions style={{ width: '100%', textAlign: 'right' }}>
                        <FlatButton label={`開く`} onClick={this.dialogOpen.bind(this)}/>
                        <FlatButton label="ダウンロード" onClick={this.handleCsvDownload(
                            kind,
                            month,
                            costs,
                            dataSource,
                            this.handleDownloadStart.bind(this),
                            this.handleDownloadEnd.bind(this)
                        ).bind(this)}/>
                    </CardActions>
                    {/*<CardText style={{marginBottom: 10}}>*/}
                        {/*<div className="row">*/}
                            {/*<div className="col">*/}
                                {/*<YosanLeaner2 budget={0} result={0}/>*/}
                            {/*</div>*/}
                        {/*</div>*/}
                    {/*</CardText>*/}
                </Card>
                {/*<Loading open={this.state.loading}/>*/}
                <Dialog
                    title={month}
                    modal={true}
                    open={this.state.dialog}
                    onRequestClose={this.dialogClose.bind(this)}
                    autoScrollBodyContent={true}
                    contentStyle={{ width: '100%', maxWidth: '1000px' }}
                    actions={actions}
                >
                    <CostMonthCardContents
                        errors={this.state.errors}
                        kind={kind}
                        onMounted={this.loadingStop.bind(this)}
                        loading={true}
                        name={name}
                        costs={costs}
                        dataSourceConfig={dataSourceConfig}
                        dataSourceType={dataSourceType}
                        dataSource={dataSource}
                        resultDisable={resultDisable}
                        status={status}
                        parentIndex={parentIndex}
                        dispatch={dispatch}
                    />
                </Dialog>


            </div>
        )
    }
}

export default CostMonthCard;



// WEBPACK FOOTER //
// ./src/components/CostMonthCard.js